import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import QuestionsEditTab from './Elements/QuestionsEditTab';
import QuestionMattersTab from './Elements/QuestionMattersTab';
import QuestionIncompatibilitiesTab from './Elements/QuestionIncompatibilitiesTab';
import QuestionOptionsTab from './Elements/QuestionOptionsTab';
import QuestionCategoriesTab from './Elements/QuestionCategoriesTab';

class QuestionsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      question_data: {},
      lista_dificuldades: {},
      opcoes: {},
      materias: {},
      categorias: {},
      lista_materias: {},
      lista_categorias: {},
      incompatibilidades: {},
      lista_questoes: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  refreshTable (event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questao/buscar_opcoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/questoes');
        if (responseJson.status === 'success') {
          self.setState({opcoes: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }
  
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/questoes');
        if (responseJson.status === 'success') {
          self.setState({question_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questoes/dificuldade/listar';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_dificuldades: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questao/buscar_opcoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({opcoes: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questao/buscar_materias/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questao/buscar_categorias/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({categorias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/materias/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questao/buscar_incompatibilidades/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({incompatibilidades: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/questoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_questoes: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/categorias/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_categorias: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Lista Questões */ }); /* Incompatibilidades */ }); /* Lista Matérias */ }); /* Matérias */ }); /* Opções */ }); /* Lista Dificuldades */ }); /* Categorias */ }); /* Lista Categorias */
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de questão</h3>
      <Link to="/questoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados da questão">
          <QuestionsEditTab handleAlert={this.handleAlert} question_id={this.props.match.params.id} question_data={this.state.question_data} lista_dificuldades={this.state.lista_dificuldades} />
        </Tab>
        <Tab eventKey={2} title="Opções">
          <QuestionOptionsTab handleAlert={this.handleAlert} refreshTable={this.refreshTable} opcoes={this.state.opcoes} question_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={3} title="Matérias">
          <QuestionMattersTab handleAlert={this.handleAlert} materias={this.state.materias} lista_materias={this.state.lista_materias} question_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={4} title="Categorias">
          <QuestionCategoriesTab handleAlert={this.handleAlert} categorias={this.state.categorias} lista_categorias={this.state.lista_categorias} question_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={5} title="Incompatibilidade">
          <QuestionIncompatibilitiesTab handleAlert={this.handleAlert} incompatibilidades={this.state.incompatibilidades} lista_questoes={this.state.lista_questoes} question_id={this.props.match.params.id} />
        </Tab>
      </Tabs>      
    </div>
  </div>
</div>
    );
  }
}

export default QuestionsEdit;



// WEBPACK FOOTER //
// ./src/Components/Questions/QuestionsEdit.js